import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M3.498 3.394v9.605a.5.5 0 00.75.433l8.992-5.19a.5.5 0 000-.867l-8.991-5.19v0l-1-.578"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.248 5.09V19.5a.75.75 0 001.125.65l13.487-7.787a.75.75 0 000-1.3L6.374 3.278v0l-1.5-.867"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.496 10.182v28.816c0 1.154 1.25 1.878 2.25 1.3L39.72 24.724c1-.578 1-2.02 0-2.598L12.748 6.554v-.001l-3-1.732"
  }))
};
export var Play = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});